import {
  newPTSDFollowUpDescription,
  disabilityNameTitle,
} from '../content/newPTSDFollowUp';

export const uiSchema = {
  'ui:title': disabilityNameTitle,
  'ui:description': newPTSDFollowUpDescription,
};

export const schema = {
  type: 'object',
  properties: {},
};
